export default "__VITE_ASSET__daa002cd__"